import { render, staticRenderFns } from "./RentalToClothes.vue?vue&type=template&id=79e09ae6&"
import script from "./RentalToClothes.vue?vue&type=script&lang=js&"
export * from "./RentalToClothes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports